import React, { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { MenuClient } from "../MenuClient"
import { Header } from "../../common/header/Header"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { IMG } from "../../common/CONST"
import { IPageResponse } from "../../../types/IPageResponse"
import { IClientRequestDto } from "../../../types/request/IClientRequestDto"
import { useNavigate, useSearchParams } from "react-router-dom"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import InfiniteScroll from "react-infinite-scroll-component"
import { ClientRequestListItem } from "./ClientRequestListItem"
import { RequestPopUp } from "../../common/element/RequestPopUp"
import { RequestStatus } from "../../../types/request/RequestStatus"
import { IRequestStatus } from "../../../types/request/IRequestStatus"
import { Messenger } from "../../common/messenger/Messenger"
import { ICheckConversationResponse } from "../../../types/messenger/ICheckConversationResponse"
import { CONFIG } from "../../../CONFIG"
import Button from "@/ui/components/Button"
import { CURRENCY_REPLENISHMENT_ROUTE, REPLENISHMENT_ROUTE, REQUEST_ROUTE } from "@/routes"
import { useUpdateEffect } from "react-use"
import Skeleton from "@/ui/components/Skeleton"
import EmptyRow from "@/ui/components/EmptyRow"
import Input from "@/ui/components/Input"
import { CurrencyRequestPopUp } from "@/components/common/element/CurrencyRequestPopUp"

enum RequestVariant {
  Ruble = "ruble",
  Currency = "currency"
}

export const ClientRequestList = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const [showRequestPopUp, setShowRequestPopUp] = useState(false)
  const [showCurrencyRequestPopUp, setShowCurrencyRequestPopUp] = useState(false)
  const [requestVariant, setRequestVariant] = useState<RequestVariant>(() =>
    searchParams.get("type") === RequestVariant.Currency ? RequestVariant.Currency : RequestVariant.Ruble
  )
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [approvedRequestNumber, setApprovedRequestNumber] = useState<any>()
  const [rejectedRequestNumber, setRejectedRequestNumber] = useState<any>()
  const [requestList, setRequestList] = useState<IPageResponse<IClientRequestDto>>()
  const [searchQuery, setSearchQuery] = useState("")
  const [page, setPage] = useState(0)
  const [isLoading, setLoading] = useState(true)
  const [isRefetchLoading, setRefetchLoading] = useState(false)

  const isCurrencyVariant = requestVariant === RequestVariant.Currency

  /* Messenger const */
  const [instanceId, setInstanceId] = useState<string>()
  const [conversationUserId, setConversationUserId] = useState<number>()
  const CHAT_INSTANCE = "REQUEST"
  const [unreadList, setUnreadList] = useState<IPageResponse<ICheckConversationResponse>>()

  const fetchUnread = () => {
    TrinityAPI.getUnreadConversations(CHAT_INSTANCE, response => {
      if (response.status === 200) {
        setUnreadList(response.data)
      }
    })
  }

  const fetchRequests = (isRefetch: boolean = false) => {
    TrinityAPI.getClientRequests(
      isRefetch ? CONFIG.defaultPage : page,
      searchParams.get("status") || "",
      searchQuery,
      response => {
        if (response.status === 200) {
          const currentItems = page === 0 || isRefetch ? [] : requestList?.items || []
          setPage(page + 1)
          setRequestList({
            ...requestList,
            items: currentItems.concat(response.data.items),
            totalPages: response.data.totalPages
          })
        } else {
          setModalMessage({
            title: "Ошибка!",
            text: "Ошибка загрузки запросов: " + response.data.message
          })
        }
      },
      () => {
        setLoading(false)
        isRefetch && setRefetchLoading(false)
      }
    )
  }

  const fetchCurrencyRequests = (isRefetch: boolean = false) => {
    TrinityAPI.getClientCurrencyRequests(
      isRefetch ? CONFIG.defaultPage : page,
      searchParams.get("status") || "",
      searchQuery,
      response => {
        if (response.status === 200) {
          const currentItems = page === 0 || isRefetch ? [] : requestList?.items || []
          setPage(page + 1)
          setRequestList({
            ...requestList,
            items: currentItems.concat(response.data.items),
            totalPages: response.data.totalPages
          })
        } else {
          setModalMessage({
            title: "Ошибка!",
            text: "Ошибка загрузки запросов: " + response.data.message
          })
        }
      },
      () => {
        setLoading(false)
        isRefetch && setRefetchLoading(false)
      }
    )
  }

  const showModal = (id: number) => {
    const request = requestList?.items.filter(r => r.id === id)[0]
    if (!request) return
    if (request.status === "NEW") {
      setModalMessage({
        ...modalMessage,
        title: `Статус заявки №${request.id}`,
        h1: "В обработке",
        text: "На данный момент заявка находится в обработке. Это может занять до нескольких дней. Наберитесь терпения. После подтверждения или отколнения заявки она перейдет во вкладку с одноименным статусом"
      })
    } else if (request.status === "APPROVED") {
      setApprovedRequestNumber(id)
    } else if (request.status === "REJECTED") {
      setRejectedRequestNumber(id)
    }
  }

  const getRejectedRequest = (id: number) => {
    const req: IClientRequestDto = {}
    return requestList?.items.filter(i => i.id === id)[0] || req
  }

  const deleteRequest = (id: number) => {
    TrinityAPI.deleteClientRequest(id, response => {
      if (response.status === 200) {
        fetchRequests(true)
      }
    })
  }

  const changeStatusFilter = (status: string) => {
    navigate(`${REQUEST_ROUTE}?status=${status}`)
  }

  const closeMessenger = () => {
    setInstanceId(undefined)
    setConversationUserId(undefined)
  }

  const showMessenger = (instanceId: string | undefined, userId: number | undefined) => {
    setInstanceId(instanceId)
    setConversationUserId(userId)
  }

  const refetchData = () => {
    setRefetchLoading(true)
    !isCurrencyVariant ? fetchRequests(true) : fetchCurrencyRequests(true)
  }

  useEffect(() => {
    if (page === 0) {
      !isCurrencyVariant ? fetchRequests() : fetchCurrencyRequests()
    }
  }, [page])

  useUpdateEffect(() => {
    !isCurrencyVariant ? fetchRequests(true) : fetchCurrencyRequests(true)
  }, [searchParams, requestVariant, searchQuery])

  useEffect(() => {
    fetchUnread()

    const intervalId = setInterval(() => {
      fetchUnread()
    }, CONFIG.fetchUnreadsInterval)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />

      {approvedRequestNumber && (
        <section className="popup-forms index-top">
          <div className="container-popup-forms">
            <button className="close-btn-card" onClick={() => setApprovedRequestNumber(undefined)} />
            <div className="popup-card">
              <h4 className="heading-chapter">Статус запроса №{approvedRequestNumber}</h4>
              <p className="ui-heading">Запрос подтвержден</p>
              <p className="text-block">Менеджер подтвердил запрос. На его основе вы можете произвести пополнение</p>
              <div className="flex-row-24">
                <Button
                  onClick={() =>
                    navigate(
                      requestVariant === RequestVariant.Ruble ? REPLENISHMENT_ROUTE : CURRENCY_REPLENISHMENT_ROUTE
                    )
                  }
                >
                  К пополнениям
                </Button>
              </div>
            </div>
          </div>
        </section>
      )}

      {rejectedRequestNumber && (
        <section className="popup-forms index-top" id="request_info-error">
          <div className="container-popup-forms">
            <button className="close-btn-card" onClick={() => setRejectedRequestNumber(undefined)} />
            <div className="popup-card">
              <h4 className="heading-chapter">Статус заявки №{rejectedRequestNumber}</h4>
              <p className="ui-heading">Заявка отклонена</p>
              <p className="text-block">{getRejectedRequest(rejectedRequestNumber).comment}</p>
              <div className="flex-row-24">
                <Button onClick={() => deleteRequest(rejectedRequestNumber)}>Удалить заявку</Button>
              </div>
            </div>
          </div>
        </section>
      )}

      <MenuClient active={"request"} />
      <main className="main-container" id="scrollable">
        <Header />
        <div className="container">
          <ul className="nav-global-list">
            <li
              className={`nav-global-item${
                !searchParams.get("status") || searchParams.get("status") === "" ? "-active" : ""
              }`}
              onClick={() => navigate(REQUEST_ROUTE)}
            >
              Все
            </li>
            <li
              className={`nav-global-item${searchParams.get("status") === "NEW" ? "-active" : ""}`}
              onClick={() => navigate(`${REQUEST_ROUTE}?status=NEW`)}
            >
              Новые
            </li>
            <li
              className={`nav-global-item${searchParams.get("status") === "APPROVED" ? "-active" : ""}`}
              onClick={() => navigate(`${REQUEST_ROUTE}?status=APPROVED`)}
            >
              Подтверждены
            </li>
            <li
              className={`nav-global-item${searchParams.get("status") === "REJECTED" ? "-active" : ""}`}
              onClick={() => navigate(`${REQUEST_ROUTE}?status=REJECTED`)}
            >
              Отклонены
            </li>
            <li
              className={`nav-global-item${searchParams.get("status") === "USED" ? "-active" : ""}`}
              onClick={() => navigate(`${REQUEST_ROUTE}?status=USED`)}
            >
              С пополнением
            </li>
          </ul>

          <h1 className="ui-heading">
            {searchParams.get("status") === "APPROVED"
              ? "Подтвержденные"
              : searchParams.get("status") === "REJECTED"
              ? "Отклоненные"
              : searchParams.get("status") === "NEW"
              ? "Новые"
              : searchParams.get("status") === "USED"
              ? "С пополнением"
              : "Все"}
          </h1>

          <section className="header-chapter">
            <div className="headr-chapter-name">
              <div className="header-chapter-icon">
                <img src={IMG.requests} alt="" className="header-chapter-img" />
              </div>
              <Button variant="black" onClick={refetchData} loading={isRefetchLoading}>
                Обновить список запросов
              </Button>
            </div>
            <div className="flex-row-24 flex-wrap">
              <Button
                id="new-requset"
                onClick={() => setShowRequestPopUp(true)}
                leftIcon={<img src={IMG.plus_btn} className="img-btn" alt="Plus button" />}
              >
                Создать рублевый запрос
              </Button>
              <Button
                id="new-requset"
                onClick={() => setShowCurrencyRequestPopUp(true)}
                leftIcon={<img src={IMG.plus_btn} className="img-btn" alt="Plus button" />}
              >
                Создать валютный запрос
              </Button>
            </div>
          </section>

          <section className="search-block">
            <Input
              type="search"
              onChange={e => setSearchQuery(e.target.value)}
              value={searchQuery}
              placeholder="Название компании, ИНН, валюта или номер запроса"
            />
          </section>

          <div className="flex-row-24 justify-end">
            <Button
              variant={!isCurrencyVariant ? "black" : "grey"}
              onClick={() => setRequestVariant(RequestVariant.Ruble)}
            >
              Рублевые
            </Button>
            <Button
              variant={isCurrencyVariant ? "black" : "grey"}
              onClick={() => setRequestVariant(RequestVariant.Currency)}
            >
              Валютные
            </Button>
          </div>

          <div className="main-content--wrapper">
            <section className="main-content">
              <ul className="header-global-list">
                <li className="header-global-item width-130">Дата и номер</li>
                <li className="header-global-item cols-request">Юрисдикция</li>
                {!isCurrencyVariant && <li className="header-global-item cols-request">ИНН</li>}
                <li className="header-global-item cols-request">Название {!isCurrencyVariant && "компании"}</li>
                <li className="header-global-item cols-request">Сумма</li>
                <li className="header-global-item width-130">Валюта</li>
                <li className="header-global-item width-130">
                  <select
                    value={searchParams.get("status") || ""}
                    className="select-style"
                    onChange={e => changeStatusFilter(e.target.value)}
                  >
                    <option value="" key="EMPTY">
                      Все
                    </option>
                    <option value="APPROVED">Требуется действие</option>
                    {Object.keys(RequestStatus).map(key => (
                      <option value={key} key={key}>
                        {RequestStatus[key as keyof IRequestStatus]}
                      </option>
                    ))}
                  </select>
                </li>
              </ul>
              <ul className="global-list">
                {isLoading ? (
                  <div className="skeleton-wrapper">
                    <Skeleton rows={4} gutterTop />
                  </div>
                ) : (
                  <InfiniteScroll
                    scrollableTarget="scrollable"
                    next={fetchRequests}
                    hasMore={page < (requestList?.totalPages || 0)}
                    loader={<Skeleton gutterTop />}
                    dataLength={requestList?.items.length || 0}
                    className="message-list"
                    style={{ listStyleType: "none" }}
                  >
                    {(requestList?.items?.length || 0) > 0 ? (
                      requestList?.items.map((r, index) => (
                        <ClientRequestListItem
                          request={r}
                          action={showModal}
                          isCurrencyVariant={isCurrencyVariant}
                          showMessenger={showMessenger}
                          unreadList={unreadList}
                          key={index}
                        />
                      ))
                    ) : (
                      <EmptyRow text="Запросов не найдено" />
                    )}
                  </InfiniteScroll>
                )}
              </ul>
            </section>
          </div>
        </div>
      </main>
      <RequestPopUp visible={showRequestPopUp} setVisible={setShowRequestPopUp} />
      <CurrencyRequestPopUp visible={showCurrencyRequestPopUp} setVisible={setShowCurrencyRequestPopUp} />
      <Messenger instanceId={instanceId} type={CHAT_INSTANCE} userId={conversationUserId} close={closeMessenger} />
    </>
  )
}
